<script lang="ts">
	import vm from '@journeys/Journeys.viewmodel'

	import ToastLibrary from './ToastLibrary'

	// directives
	import { vNotify } from '@shared/components/Alerts/Toast'

	// components
	import Notification from '@shared/components/Alerts/Notification.vue'
	import { requestFrame } from '@shared/utils'
</script>

<script lang="ts" setup>
	const { toast } = vm
	toast.addToLibrary(ToastLibrary)

	const closeNote = (pos: string, sc: number) => {
		let el = toast.els[sc],
			rect = el.getBoundingClientRect()

		el.style.transitionDuration = '.6s'
		el.style.zIndex = '10'

		requestFrame(() => {
			el.style.marginTop = `${0}px`
			el.style.height = `${0}px`
			el.style.transform = `translate3d(0,${-rect.height * 1.5}px,0) scale(.94)`
			el.style.opacity = '0'

			exit()
		})

		const exit = () => {
			setTimeout(() => {
				delete toast.groups[pos][sc]
			}, toast.time.linger)
		}
	}
</script>

<template>
	<div class="toast-group top-left">
		<transition-group name="note">
			<Notification
				v-for="note in toast.groups['top-center']"
				:key="`toast${note.sc}`"
				v-notify="{ toast, pos: note.pos, sc: note.sc }"
				:type="note.type"
				:message="note.message"
				sizing="small"
				:placement="note.pos"
				:allowClose="true"
				:closeNote="() => closeNote(note.pos, note.sc)" />
		</transition-group>
	</div>
</template>

<style lang="less">
	.note-enter-active {
		transition-property: opacity, transform;
		transition-duration: 0.65s;
		transition-timing-function: ease;
	}

	.note-enter-from {
		transform: translate3d(0, 4rem, 0);
		opacity: 0;
	}

	.toast-group.top-left {
		position: fixed;
		top: 0;
		left: 0;
		margin: 0.938rem;
		z-index: 2050;
	}

	/*
	.toast-group.top-center {
		position: fixed;
		top: 80px;
		left: 50%;
		transform: translate3d(-50%, 0, 0);
		z-index: 20;
	}
    */

	.toast-group .notification-wrapper:not(.note-enter-active) {
		position: relative;
		transition-property: height, transform, opacity, margin-top;
		transition-duration: 1.4s;
		transition-timing-function: ease-out;
	}
</style>
